import {compareDesc} from 'date-fns';

import {isNotNil} from 'ramda';

import {invalidateOnSuccess, omneticApi} from '@dms/api/base';
import {EntityResourceIds} from '@dms/api/shared';

import {parseDate} from 'shared/web';

import {
  ListSentToastNotificationsApiResponse,
  ListSentToastNotificationsApiArg,
  PatchUnreadSentToastNotificationsApiArg,
  PatchSentToastNotificationApiResponse,
  PatchSentToastNotificationApiArg,
  GetSentToastNotificationApiResponse,
  GetSentToastNotificationApiArg,
  RenderCustomerEmailTemplateApiArg,
  RenderCustomerEmailTemplateApiResponse,
  RenderCustomerEmailTemplateExampleApiArg,
  RenderCustomerEmailTemplateExampleApiResponse,
  RenderCustomerSmsTemplateApiArg,
  RenderCustomerSmsTemplateApiResponse,
  RenderCustomerSmsTemplateExampleApiArg,
  RenderCustomerSmsTemplateExampleApiResponse,
  RenderBusinessCaseEmailTemplateApiArg,
  RenderBusinessCaseEmailTemplateApiResponse,
  RenderBusinessCaseSmsTemplateApiArg,
  RenderBusinessCaseSmsTemplateApiResponse,
  ListContextParametersApiArg,
  ListContextParametersApiResponse,
  CreateMessageTemplateApiArg,
  CreateMessageTemplateApiResponse,
  GetMessageTemplateApiArg,
  GetMessageTemplateApiResponse,
  PatchMessageTemplateApiArg,
  PatchMessageTemplateApiResponse,
  DeleteMessageTemplateApiArg,
  DeleteMessageTemplateApiResponse,
  GetContextTemplateListApiArg,
  GetContextTemplateListApiResponse,
  ListNotificationDefinitionsApiArg,
  ListNotificationDefinitionsApiResponse,
  GetToastNotificationExampleApiArg,
  GetToastNotificationExampleApiResponse,
  PreviewEmailNotificationApiResponse,
  PreviewEmailNotificationApiArg,
  RenderServiceOrderEmailTemplateApiArg,
  RenderServiceOrderEmailTemplateApiResponse,
  RenderServiceOrderEmailTemplateExampleApiArg,
  RenderServiceOrderEmailTemplateExampleApiResponse,
  RenderServiceOrderSmsTemplateApiArg,
  RenderServiceOrderSmsTemplateApiResponse,
  RenderServiceOrderSmsTemplateExampleApiArg,
  RenderServiceOrderSmsTemplateExampleApiResponse,
  PatchTenantNotificationSettingsApiResponse,
  PatchTenantNotificationSettingsApiArg,
  PatchUserNotificationSettingsApiArg,
  PatchUserNotificationSettingsApiResponse,
  GetNotificationSettingsApiArg,
  GetNotificationSettingsApiResponse,
  GetNotificationDefinitionsApiResponse,
  GetNotificationDefinitionsApiArg,
  RenderEmailTemplateResponseBody,
  RenderSmsTemplateResponseBody,
  CreateSignatureApiArg,
  CreateSignatureApiResponse,
  ListSignaturesApiArg,
  ListSignaturesApiResponse,
  RemoveSignatureApiArg,
  RemoveSignatureApiResponse,
  UpdateSignatureApiArg,
  UpdateSignatureApiResponse,
  GetSignatureImagePermanentUriApiArg,
  GetSignatureImagePermanentUriApiResponse,
  SendCustomerEmailApiArg,
  SendCustomerEmailApiResponse,
  SendCustomerEmailReplyApiArg,
  SendCustomerEmailReplyApiResponse,
  RenderCustomerEmailReplyApiArg,
  RenderCustomerEmailReplyApiResponse,
  AssignSyncedMessageCustomerApiArg,
  UnassignSyncedMessageCustomerApiArg,
  AssignSyncedMessageRecordApiArg,
  UnassignSyncedMessageRecordApiArg,
  MarkSyncedMessagesAsReadApiResponse,
  MarkSyncedMessagesAsReadApiArg,
  MarkCommunicationsAsOpenedApiResponse,
  MarkCommunicationsAsOpenedApiArg,
  MarkCommunicationsAsReadApiResponse,
  MarkCommunicationsAsReadApiArg,
  MarkCommunicationsAsUnreadApiResponse,
  MarkCommunicationsAsUnreadApiArg,
  GetRecordUnreadCommunicationCountApiResponse,
  GetRecordUnreadCommunicationCountApiArg,
  GetUnreadCommunicationCountApiResponse,
  GetUnreadCommunicationCountApiArg,
  CreateEmailSmtpCredentialsApiArg,
  CreateEmailSmtpCredentialsApiResponse,
  TestEmailSmtpCredentialsApiArg,
  TestEmailSmtpCredentialsApiResponse,
  CreateMicrosoftOAuth2CredentialsApiArg,
  CreateMicrosoftOAuth2CredentialsApiResponse,
  DeleteEmailCredentialsApiArg,
  DeleteEmailCredentialsApiResponse,
  DiscoverEmailProviderApiArg,
  DiscoverEmailProviderApiResponse,
  ListEmailCredentialsApiArg,
  ListEmailCredentialsApiResponse,
  SetDefaultEmailCredentialsApiArg,
  SetDefaultEmailCredentialsApiResponse,
  ClearDefaultEmailCredentialsApiArg,
  ClearDefaultEmailCredentialsApiResponse,
  ListEmailProviderApiArg,
  ListEmailProviderApiResponse,
  PatchEmailSmtpCredentialsApiArg,
  PatchEmailSmtpCredentialsApiResponse,
  GetLastKnownEmailCredentialsApiArg,
  GetLastKnownEmailCredentialsApiResponse,
  StartMicrosoftOAuth2ApiArg,
  StartMicrosoftOAuth2ApiResponse,
  CompleteMicrosoftOAuth2ApiArg,
  CompleteMicrosoftOAuth2ApiResponse,
  SendCustomerSmsApiArg,
  SendCustomerSmsApiResponse,
  RenderCustomerMessageEmailTemplateApiArg,
  RenderCustomerMessageEmailTemplateApiResponse,
  RenderCustomerMessageSmsTemplateApiArg,
  RenderCustomerMessageSmsTemplateApiResponse,
  RenderRentalOrderEmailTemplateApiArg,
  RenderRentalOrderEmailTemplateApiResponse,
  RenderRentalOrderEmailTemplateExampleApiArg,
  RenderRentalOrderEmailTemplateExampleApiResponse,
  RenderRentalOrderSmsTemplateApiArg,
  RenderRentalOrderSmsTemplateApiResponse,
  RenderRentalOrderSmsTemplateExampleApiArg,
  RenderRentalOrderSmsTemplateExampleApiResponse,
  RenderVehicleEmailTemplateApiArg,
  RenderVehicleEmailTemplateApiResponse,
  RenderVehicleEmailTemplateExampleApiArg,
  RenderVehicleEmailTemplateExampleApiResponse,
  RenderVehicleSmsTemplateApiArg,
  RenderVehicleSmsTemplateApiResponse,
  RenderVehicleSmsTemplateExampleApiArg,
  RenderVehicleSmsTemplateExampleApiResponse,
  RenderTireSetEmailTemplateExampleApiArg,
  RenderTireSetEmailTemplateExampleApiResponse,
  RenderTireSetSmsTemplateExampleApiArg,
  RenderTireSetSmsTemplateExampleApiResponse,
  renderTireSetEmailTemplateExampleApiArgSchema,
  renderTireSetSmsTemplateExampleApiArgSchema,
  RenderInterestEmailTemplateApiArg,
  RenderInterestEmailTemplateApiResponse,
  RenderInterestEmailTemplateExampleApiArg,
  RenderInterestEmailTemplateExampleApiResponse,
  RenderInterestSmsTemplateApiArg,
  RenderInterestSmsTemplateApiResponse,
  RenderInterestSmsTemplateExampleApiArg,
  RenderInterestSmsTemplateExampleApiResponse,
  RenderWorkshopInterestEmailTemplateApiArg,
  RenderWorkshopInterestEmailTemplateApiResponse,
  RenderWorkshopInterestEmailTemplateExampleApiArg,
  RenderWorkshopInterestEmailTemplateExampleApiResponse,
  RenderWorkshopInterestSmsTemplateApiArg,
  RenderWorkshopInterestSmsTemplateApiResponse,
  RenderWorkshopInterestSmsTemplateExampleApiArg,
  RenderWorkshopInterestSmsTemplateExampleApiResponse,
  renderEmailTemplateResponseBodySchema,
  renderSmsTemplateResponseBodySchema,
  renderInterestEmailTemplateApiArgSchema,
  renderInterestEmailTemplateExampleApiArgSchema,
  renderInterestSmsTemplateApiArgSchema,
  renderInterestSmsTemplateExampleApiArgSchema,
  renderWorkshopInterestEmailTemplateApiArgSchema,
  renderWorkshopInterestEmailTemplateExampleApiArgSchema,
  renderWorkshopInterestSmsTemplateApiArgSchema,
  renderWorkshopInterestSmsTemplateExampleApiArgSchema,
  GetCustomerMessageDefinitionApiArg,
  GetCustomerMessageDefinitionApiResponse,
  ListLatestSchedulerRunsApiArg,
  ListLatestSchedulerRunsApiResponse,
  DeleteLatestSchedulerRunApiArg,
  DeleteLatestSchedulerRunApiResponse,
  RunSchedulerApiArg,
  RunSchedulerApiResponse,
  PatchOAuthEmailCredentialsApiArg,
  PatchOAuthEmailCredentialsApiResponse,
  SendWhatsAppContentMessageApiArg,
  SendWhatsAppContentMessageApiResponse,
  RenderCustomerMessageEmailTemplateV2ApiArg,
  RenderCustomerMessageEmailTemplateV2ResponseBody,
  GetMessagingAllowlistApiArg,
  GetMessagingAllowlistApiResponse,
  UpdateMessagingAllowlistApiArg,
  UpdateMessagingAllowlistApiResponse,
  CreateGoogleUserMailboxApiArg,
  CreateGoogleUserMailboxApiResponse,
  ListUserMailboxesApiArg,
  ListUserMailboxesApiResponse,
  ListCustomerMessagesApiArg,
  ListCustomerMessagesApiResponse,
  CreateMicrosoftUserMailboxApiArg,
  CreateMicrosoftUserMailboxApiResponse,
  CreateImapUserMailboxApiArg,
  CreateImapUserMailboxApiResponse,
  UpdateImapUserMailboxApiArg,
  UpdateImapUserMailboxApiResponse,
  DeleteUserMailboxApiArg,
  DeleteUserMailboxApiResponse,
  ReauthenticateUserMailboxApiArg,
  ReauthenticateUserMailboxApiResponse,
  ListTenantMailboxesApiArg,
  ListTenantMailboxesApiResponse,
  CreateGoogleTenantMailboxApiArg,
  CreateGoogleTenantMailboxApiResponse,
  CreateMicrosoftTenantMailboxApiArg,
  CreateMicrosoftTenantMailboxApiResponse,
  CreateImapTenantMailboxApiArg,
  CreateImapTenantMailboxApiResponse,
  DeleteTenantMailboxApiArg,
  DeleteTenantMailboxApiResponse,
  ReauthenticateTenantMailboxApiArg,
  ReauthenticateTenantMailboxApiResponse,
} from './types';

const OWNED_UNREAD_COUNT_TAG = {type: 'CommunicationUnreadCount', id: 'OWNED'} as const;

// A read-state change moves the unread count of every record the message is linked to and of every
// owner. Of those, only the owner count and the count of the open record are ever mounted: the
// Kanban cards read their count from the grid, and a record badge refetches on mount. So a caller
// that knows its record refetches just those two; otherwise every count refetches.
const invalidateReadStateTags = (
  _result: unknown,
  queryArg: Pick<MarkCommunicationsAsReadApiArg, 'customerId' | 'resourceId' | 'recordId'>
) => {
  const messageTag = isNotNil(queryArg.customerId)
    ? ({type: 'CustomerMessage', id: queryArg.customerId} as const)
    : ('CustomerMessage' as const);

  return isNotNil(queryArg.resourceId) && isNotNil(queryArg.recordId)
    ? ([
        OWNED_UNREAD_COUNT_TAG,
        {type: 'CommunicationUnreadCount', id: `${queryArg.resourceId}-${queryArg.recordId}`},
        messageTag,
      ] as const)
    : (['CommunicationUnreadCount', messageTag] as const);
};

// Contacting the customer from a New interest can open it on the backend (tenant setting) and make
// the sender its owner. Refetch what `openInterest` refetches; the frontend does not know the setting.
const getContactedInterestTags = (body: {resourceId?: string | null; recordId?: string | null}) =>
  body.resourceId === EntityResourceIds.interest && isNotNil(body.recordId)
    ? ([
        {type: 'Interest', id: body.recordId},
        {type: 'InterestActivity', id: body.recordId},
        'participation',
        'InterestCount',
        'PersonnelOverviewInterest',
      ] as const)
    : [];

export const messagingApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    listSentToastNotifications: build.query<
      ListSentToastNotificationsApiResponse,
      ListSentToastNotificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/toast-notification`,
        params: {limit: queryArg.limit, after: queryArg.after},
      }),
      // BE doesn't keep stable order within notifications with the same createdAt
      transformResponse: (response: ListSentToastNotificationsApiResponse) => ({
        ...response,
        notifications: response.notifications.sort((a, b) => {
          const dateComparison = compareDesc(parseDate(a.createdAt), parseDate(b.createdAt));
          if (dateComparison === 0) {
            return b.id.localeCompare(a.id);
          }
          return dateComparison;
        }),
      }),
      providesTags: (result) =>
        result?.notifications
          ? [
              ...result.notifications.map(({id}) => ({type: 'Notification' as const, id})),
              {type: 'Notification', id: 'LIST'},
            ]
          : [{type: 'Notification', id: 'LIST'}],
    }),
    listContextParameters: build.query<
      ListContextParametersApiResponse,
      ListContextParametersApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/${queryArg.context}/parameter`,
      }),
    }),
    getSentToastNotification: build.query<
      GetSentToastNotificationApiResponse,
      GetSentToastNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/toast-notification/${queryArg.id}`,
      }),
    }),

    getSentBackgroundNotification: build.query<
      GetSentToastNotificationApiResponse,
      GetSentToastNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/background-notification/${queryArg.id}`,
      }),
    }),

    patchUnreadSentToastNotifications: build.mutation<
      unknown,
      PatchUnreadSentToastNotificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/toast-notification/unread`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: [{type: 'Notification', id: 'LIST'}],
    }),
    sendCustomerEmail: build.mutation<SendCustomerEmailApiResponse, SendCustomerEmailApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-email`,
        method: 'POST',
        body: queryArg.sendCustomerEmailRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'BusinessCaseActivity',
        'InterestActivity',
        'WorkshopInterestActivity',
        'DirectSaleActivity',
        'DirectSaleUpcomingTasks',
        'ServiceCaseActivity',
        'ServiceCaseCustomerMessages',
        'CustomerMessage',
        ...getContactedInterestTags(queryArg.sendCustomerEmailRequestBody),
      ],
    }),
    sendCustomerEmailReply: build.mutation<
      SendCustomerEmailReplyApiResponse,
      SendCustomerEmailReplyApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-email-reply`,
        method: 'POST',
        body: queryArg.sendCustomerEmailReplyRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'BusinessCaseActivity',
        'InterestActivity',
        'WorkshopInterestActivity',
        'DirectSaleActivity',
        'DirectSaleUpcomingTasks',
        'CustomerMessage',
        ...getContactedInterestTags(queryArg.sendCustomerEmailReplyRequestBody),
      ],
    }),
    renderCustomerEmailReply: build.mutation<
      RenderCustomerEmailReplyApiResponse,
      RenderCustomerEmailReplyApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-email-reply/render`,
        method: 'POST',
        body: queryArg.renderCustomerEmailReplyRequestBody,
      }),
    }),
    assignSyncedMessageCustomer: build.mutation<void, AssignSyncedMessageCustomerApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/synced-message/${queryArg.syncedMessageId}/assign-customer`,
        method: 'POST',
        body: {customerId: queryArg.customerId},
      }),
      // Refresh views keyed on the message's customer (e.g. the communication thread panel).
      invalidatesTags: invalidateOnSuccess(['CustomerMessage']),
    }),
    unassignSyncedMessageCustomer: build.mutation<void, UnassignSyncedMessageCustomerApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/synced-message/${queryArg.syncedMessageId}/unassign-customer`,
        method: 'POST',
      }),
      invalidatesTags: invalidateOnSuccess(['CustomerMessage']),
    }),
    assignSyncedMessageRecord: build.mutation<void, AssignSyncedMessageRecordApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/synced-message/${queryArg.syncedMessageId}/assign-record`,
        method: 'POST',
        body: {recordId: queryArg.recordId},
      }),
      // Moving a message between records moves its unread count; assigning also reads it, which
      // changes its state in the thread.
      invalidatesTags: invalidateOnSuccess(['CustomerMessage', 'CommunicationUnreadCount']),
    }),
    unassignSyncedMessageRecord: build.mutation<void, UnassignSyncedMessageRecordApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/synced-message/${queryArg.syncedMessageId}/unassign-record`,
        method: 'POST',
      }),
      // Moving a message between records moves its unread count; assigning also reads it, which
      // changes its state in the thread.
      invalidatesTags: invalidateOnSuccess(['CustomerMessage', 'CommunicationUnreadCount']),
    }),
    markSyncedMessagesAsRead: build.mutation<
      MarkSyncedMessagesAsReadApiResponse,
      MarkSyncedMessagesAsReadApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/synced-message/mark-all-read`,
        method: 'POST',
        body: {receivedBefore: queryArg.receivedBefore, recordId: queryArg.recordId},
      }),
      // Runs only with the read state flag off, when no unread count is requested.
      invalidatesTags: invalidateOnSuccess(['CustomerMessage']),
    }),
    // The read state is shared by every user, so any change refreshes the counts and the thread.
    // The thread keeps its per-visit "new" markers on its own, so refetching it is safe.
    markCommunicationsAsOpened: build.mutation<
      MarkCommunicationsAsOpenedApiResponse,
      MarkCommunicationsAsOpenedApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/communication/opened`,
        method: 'POST',
        body: {communicationIds: queryArg.communicationIds},
      }),
      invalidatesTags: invalidateOnSuccess(invalidateReadStateTags),
    }),
    markCommunicationsAsRead: build.mutation<
      MarkCommunicationsAsReadApiResponse,
      MarkCommunicationsAsReadApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/communication/read`,
        method: 'POST',
        body: {communicationIds: queryArg.communicationIds},
      }),
      invalidatesTags: invalidateOnSuccess(invalidateReadStateTags),
    }),
    markCommunicationsAsUnread: build.mutation<
      MarkCommunicationsAsUnreadApiResponse,
      MarkCommunicationsAsUnreadApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/communication/unread`,
        method: 'POST',
        body: {communicationIds: queryArg.communicationIds},
      }),
      invalidatesTags: invalidateOnSuccess(invalidateReadStateTags),
    }),
    getRecordUnreadCommunicationCount: build.query<
      GetRecordUnreadCommunicationCountApiResponse,
      GetRecordUnreadCommunicationCountApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/communication/record/${queryArg.resourceId}/${encodeURIComponent(queryArg.recordId)}/unread-count`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'CommunicationUnreadCount', id: `${queryArg.resourceId}-${queryArg.recordId}`},
      ],
    }),
    getUnreadCommunicationCount: build.query<
      GetUnreadCommunicationCountApiResponse,
      GetUnreadCommunicationCountApiArg
    >({
      query: () => ({
        url: `/dms/v1/communication/unread-count`,
      }),
      providesTags: [OWNED_UNREAD_COUNT_TAG],
    }),
    patchSentToastNotification: build.mutation<
      PatchSentToastNotificationApiResponse,
      PatchSentToastNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/toast-notification/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: [{type: 'Notification', id: 'LIST'}],
    }),
    createTemplate: build.mutation<CreateMessageTemplateApiResponse, CreateMessageTemplateApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/template/${queryArg.templateType}`,
        method: 'POST',
        body: queryArg.createTemplateRequestBody,
      }),
      invalidatesTags: ['MessageTemplates'],
    }),
    getTemplate: build.query<GetMessageTemplateApiResponse, GetMessageTemplateApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/template/${queryArg.templateType}/${queryArg.templateId}`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'MessageTemplate',
          id: queryArg.templateId,
        },
      ],
    }),
    patchTemplate: build.mutation<PatchMessageTemplateApiResponse, PatchMessageTemplateApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/template/${queryArg.templateType}/${queryArg.templateId}`,
        method: 'PATCH',
        body: queryArg.patchTemplateRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {
          type: 'MessageTemplate',
          id: queryArg.templateId,
        },
        'MessageTemplates',
      ],
    }),
    deleteTemplate: build.mutation<DeleteMessageTemplateApiResponse, DeleteMessageTemplateApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/template/${queryArg.templateType}/${queryArg.templateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MessageTemplates'],
    }),
    getContextTemplateList: build.query<
      GetContextTemplateListApiResponse,
      GetContextTemplateListApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/template`,
        params: {type: queryArg.type, context: queryArg.context},
      }),
      providesTags: ['MessageTemplates'],
    }),
    renderCustomerEmailTemplate: build.mutation<
      RenderCustomerEmailTemplateApiResponse,
      RenderCustomerEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/customer/render-email`,
        method: 'POST',
        body: queryArg.renderCustomerEmailTemplateRequestBody,
      }),
    }),
    renderCustomerEmailTemplateExample: build.mutation<
      RenderCustomerEmailTemplateExampleApiResponse,
      RenderCustomerEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/customer/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderCustomerSmsTemplate: build.mutation<
      RenderCustomerSmsTemplateApiResponse,
      RenderCustomerSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/customer/render-sms`,
        method: 'POST',
        body: queryArg.renderCustomerSmsTemplateRequestBody,
      }),
    }),
    renderCustomerSmsTemplateExample: build.mutation<
      RenderCustomerSmsTemplateExampleApiResponse,
      RenderCustomerSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/customer/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderServiceOrderEmailTemplate: build.mutation<
      RenderServiceOrderEmailTemplateApiResponse,
      RenderServiceOrderEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/service-order/render-email`,
        method: 'POST',
        body: queryArg.renderServiceOrderEmailTemplateRequestBody,
      }),
    }),
    renderServiceOrderEmailTemplateExample: build.mutation<
      RenderServiceOrderEmailTemplateExampleApiResponse,
      RenderServiceOrderEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/service-order/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderServiceOrderSmsTemplate: build.mutation<
      RenderServiceOrderSmsTemplateApiResponse,
      RenderServiceOrderSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/service-order/render-sms`,
        method: 'POST',
        body: queryArg.renderServiceOrderSmsTemplateRequestBody,
      }),
    }),
    renderServiceOrderSmsTemplateExample: build.mutation<
      RenderServiceOrderSmsTemplateExampleApiResponse,
      RenderServiceOrderSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/service-order/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderBusinessCaseEmailTemplate: build.mutation<
      RenderBusinessCaseEmailTemplateApiResponse,
      RenderBusinessCaseEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/business-case/render-email`,
        method: 'POST',
        body: queryArg.renderBusinessCaseEmailTemplateRequestBody,
      }),
    }),
    renderBusinessCaseSmsTemplate: build.mutation<
      RenderBusinessCaseSmsTemplateApiResponse,
      RenderBusinessCaseSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/business-case/render-sms`,
        method: 'POST',
        body: queryArg.renderBusinessCaseSmsTemplateRequestBody,
      }),
    }),
    renderBusinessCaseEmailTemplateExample: build.mutation<
      RenderEmailTemplateResponseBody,
      RenderCustomerEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/business-case/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderBusinessCaseSmsTemplateExample: build.mutation<
      RenderSmsTemplateResponseBody,
      RenderCustomerSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/business-case/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    listNotificationDefinitions: build.query<
      ListNotificationDefinitionsApiResponse,
      ListNotificationDefinitionsApiArg
    >({
      query: () => ({
        url: `/dms/v1/messaging/notification/definition`,
      }),
    }),
    getNotificationDefinitions: build.query<
      GetNotificationDefinitionsApiResponse,
      GetNotificationDefinitionsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/definition/${queryArg.id}`,
      }),
    }),
    getToastNotificationExample: build.query<
      GetToastNotificationExampleApiResponse,
      GetToastNotificationExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/definition/${queryArg.id}/example-toast-notification`,
      }),
    }),
    previewEmailNotification: build.query<
      PreviewEmailNotificationApiResponse,
      PreviewEmailNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/definition/${queryArg.id}/example-email-notification/${queryArg.locale}`,
        responseHandler: async (response) => {
          const text = await response.text();
          return text;
        },
      }),
    }),
    patchTenantNotificationSettings: build.mutation<
      PatchTenantNotificationSettingsApiResponse,
      PatchTenantNotificationSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/definition/${queryArg.id}/tenant-settings`,
        method: 'PATCH',
        body: queryArg.patchTenantNotificationSettingsRequestBody,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'notificationSettings', id: queryArg.id},
      ],
    }),
    patchUserNotificationSettings: build.mutation<
      PatchUserNotificationSettingsApiResponse,
      PatchUserNotificationSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/definition/${queryArg.id}/user-settings`,
        method: 'PATCH',
        body: queryArg.patchUserNotificationSettingsRequestBody,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'notificationSettings', id: queryArg.id},
      ],
    }),
    getNotificationSettings: build.query<
      GetNotificationSettingsApiResponse,
      GetNotificationSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/notification/definition/${queryArg.id}/settings`,
      }),
      providesTags: (result, error, queryArg) => [{type: 'notificationSettings', id: queryArg.id}],
    }),
    createSignature: build.mutation<CreateSignatureApiResponse, CreateSignatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/signature`,
        method: 'POST',
        body: queryArg.updateSignatureRequestBody,
      }),
      invalidatesTags: ['EmailSignature'],
    }),
    listSignatures: build.query<ListSignaturesApiResponse, ListSignaturesApiArg>({
      query: () => ({
        url: `/dms/v1/messaging/email/signature`,
      }),
      providesTags: ['EmailSignature'],
    }),
    removeSignature: build.mutation<RemoveSignatureApiResponse, RemoveSignatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/signature/${queryArg.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmailSignature'],
    }),
    updateSignature: build.mutation<UpdateSignatureApiResponse, UpdateSignatureApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/signature/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateSignatureRequestBody,
      }),
      invalidatesTags: ['EmailSignature'],
    }),
    getSignatureImagePermanentUri: build.query<
      GetSignatureImagePermanentUriApiResponse,
      GetSignatureImagePermanentUriApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/signature/image/${queryArg.fileId}/permanent-uri`,
      }),
    }),
    discoverEmailProvider: build.mutation<
      DiscoverEmailProviderApiResponse,
      DiscoverEmailProviderApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/provider/discover`,
        method: 'POST',
        body: queryArg.discoverEmailProviderRequestBody,
      }),
    }),
    listEmailProvider: build.query<ListEmailProviderApiResponse, ListEmailProviderApiArg>({
      query: () => ({
        url: `/dms/v1/messaging/email/credentials/provider`,
      }),
    }),
    startMicrosoftOAuth2: build.mutation<
      StartMicrosoftOAuth2ApiResponse,
      StartMicrosoftOAuth2ApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/auth/microsoft/oauth2/start`,
        method: 'POST',
        body: queryArg.startMicrosoftOAuth2RequestBody,
      }),
    }),
    completeMicrosoftOAuth2: build.mutation<
      CompleteMicrosoftOAuth2ApiResponse,
      CompleteMicrosoftOAuth2ApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/auth/microsoft/oauth2/complete`,
        method: 'POST',
        body: queryArg.completeMicrosoftOAuth2RequestBody,
      }),
    }),
    createMicrosoftOAuth2Credentials: build.mutation<
      CreateMicrosoftOAuth2CredentialsApiResponse,
      CreateMicrosoftOAuth2CredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/oauth/microsoft`,
        method: 'POST',
        body: queryArg.createMicrosoftOAuth2CredentialsRequestBody,
      }),
      invalidatesTags: ['EmailCredentials'],
    }),
    patchOAuthEmailCredentials: build.mutation<
      PatchOAuthEmailCredentialsApiResponse,
      PatchOAuthEmailCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/oauth/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.patchOAuthEmailCredentialsRequestBody,
      }),
      invalidatesTags: ['EmailCredentials'],
    }),
    createEmailSmtpCredentials: build.mutation<
      CreateEmailSmtpCredentialsApiResponse,
      CreateEmailSmtpCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/smtp`,
        method: 'POST',
        body: queryArg.createSmtpCredentialsRequestBody,
      }),
      invalidatesTags: ['EmailCredentials'],
    }),
    testEmailSmtpCredentials: build.mutation<
      TestEmailSmtpCredentialsApiResponse,
      TestEmailSmtpCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/smtp/test`,
        method: 'POST',
        body: queryArg.testSmtpEmailCredentialsRequestBody,
      }),
    }),
    deleteEmailCredentials: build.mutation<
      DeleteEmailCredentialsApiResponse,
      DeleteEmailCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/${queryArg.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EmailCredentials'],
    }),
    listEmailCredentials: build.query<ListEmailCredentialsApiResponse, ListEmailCredentialsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials`,
        params: {ownerType: queryArg.ownerType},
      }),
      providesTags: ['EmailCredentials'],
    }),
    setDefaultEmailCredentials: build.mutation<
      SetDefaultEmailCredentialsApiResponse,
      SetDefaultEmailCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/me/default`,
        method: 'PUT',
        body: queryArg.setDefaultEmailCredentialsRequestBody,
      }),
      invalidatesTags: invalidateOnSuccess(['EmailCredentials']),
    }),
    clearDefaultEmailCredentials: build.mutation<
      ClearDefaultEmailCredentialsApiResponse,
      ClearDefaultEmailCredentialsApiArg
    >({
      query: () => ({
        url: `/dms/v1/messaging/email/credentials/me/default`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidateOnSuccess(['EmailCredentials']),
    }),
    patchEmailSmtpCredentials: build.mutation<
      PatchEmailSmtpCredentialsApiResponse,
      PatchEmailSmtpCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/credentials/smtp/${queryArg.id}`,
        method: 'PATCH',
        body: queryArg.patchSmtpCredentialsRequestBody,
      }),
      invalidatesTags: ['EmailCredentials'],
    }),
    getLastKnownSmtpCredentials: build.query<
      GetLastKnownEmailCredentialsApiResponse,
      GetLastKnownEmailCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-message/${queryArg.customerMessageId}/email/last-used-credentials`,
      }),
      keepUnusedDataFor: 0,
    }),
    sendCustomerSms: build.mutation<SendCustomerSmsApiResponse, SendCustomerSmsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-sms`,
        method: 'POST',
        body: queryArg.sendCustomerSmsRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'BusinessCaseActivity',
        'InterestActivity',
        'WorkshopInterestActivity',
        'DirectSaleActivity',
        'DirectSaleUpcomingTasks',
        'ServiceCaseActivity',
        'ServiceCaseCustomerMessages',
        'CustomerMessage',
        ...getContactedInterestTags(queryArg.sendCustomerSmsRequestBody),
      ],
    }),
    sendWhatsAppContentMessage: build.mutation<
      SendWhatsAppContentMessageApiResponse,
      SendWhatsAppContentMessageApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/whatsapp/content`,
        method: 'POST',
        body: queryArg.sendWhatsAppContentMessageRequestBody,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        'BusinessCaseActivity',
        'InterestActivity',
        'WorkshopInterestActivity',
        'ServiceCaseActivity',
        'ServiceCaseCustomerMessages',
        'CustomerMessage',
        ...getContactedInterestTags(queryArg.sendWhatsAppContentMessageRequestBody),
      ],
    }),
    renderCustomerMessageEmailTemplate: build.mutation<
      RenderCustomerMessageEmailTemplateApiResponse,
      RenderCustomerMessageEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-message/${queryArg.customerMessageId}/email/render`,
        method: 'POST',
        body: queryArg.renderCustomerMessageRequestBody,
      }),
    }),
    renderCustomerMessageSmsTemplate: build.mutation<
      RenderCustomerMessageSmsTemplateApiResponse,
      RenderCustomerMessageSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-message/${queryArg.customerMessageId}/sms/render`,
        method: 'POST',
        body: queryArg.renderCustomerMessageRequestBody,
      }),
    }),
    renderRentalOrderEmailTemplate: build.mutation<
      RenderRentalOrderEmailTemplateApiResponse,
      RenderRentalOrderEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/rental-order/render-email`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderRentalOrderEmailTemplateExample: build.mutation<
      RenderRentalOrderEmailTemplateExampleApiResponse,
      RenderRentalOrderEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/rental-order/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderRentalOrderSmsTemplate: build.mutation<
      RenderRentalOrderSmsTemplateApiResponse,
      RenderRentalOrderSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/rental-order/render-sms`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderRentalOrderSmsTemplateExample: build.mutation<
      RenderRentalOrderSmsTemplateExampleApiResponse,
      RenderRentalOrderSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/rental-order/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderVehicleEmailTemplate: build.mutation<
      RenderVehicleEmailTemplateApiResponse,
      RenderVehicleEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/vehicle/render-email`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderVehicleEmailTemplateExample: build.mutation<
      RenderVehicleEmailTemplateExampleApiResponse,
      RenderVehicleEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/vehicle/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderVehicleSmsTemplate: build.mutation<
      RenderVehicleSmsTemplateApiResponse,
      RenderVehicleSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/vehicle/render-sms`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderVehicleSmsTemplateExample: build.mutation<
      RenderVehicleSmsTemplateExampleApiResponse,
      RenderVehicleSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/vehicle/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    renderTireSetEmailTemplateExample: build.mutation<
      RenderTireSetEmailTemplateExampleApiResponse,
      RenderTireSetEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/tire-set/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderTireSetEmailTemplateExampleApiArgSchema,
        responseSchema: renderEmailTemplateResponseBodySchema,
      },
    }),
    renderTireSetSmsTemplateExample: build.mutation<
      RenderTireSetSmsTemplateExampleApiResponse,
      RenderTireSetSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/tire-set/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderTireSetSmsTemplateExampleApiArgSchema,
        responseSchema: renderSmsTemplateResponseBodySchema,
      },
    }),
    renderInterestEmailTemplate: build.mutation<
      RenderInterestEmailTemplateApiResponse,
      RenderInterestEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/interest/render-email`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderInterestEmailTemplateApiArgSchema,
        responseSchema: renderEmailTemplateResponseBodySchema,
      },
    }),
    renderInterestEmailTemplateExample: build.mutation<
      RenderInterestEmailTemplateExampleApiResponse,
      RenderInterestEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/interest/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderInterestEmailTemplateExampleApiArgSchema,
        responseSchema: renderEmailTemplateResponseBodySchema,
      },
    }),
    renderInterestSmsTemplate: build.mutation<
      RenderInterestSmsTemplateApiResponse,
      RenderInterestSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/interest/render-sms`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderInterestSmsTemplateApiArgSchema,
        responseSchema: renderSmsTemplateResponseBodySchema,
      },
    }),
    renderInterestSmsTemplateExample: build.mutation<
      RenderInterestSmsTemplateExampleApiResponse,
      RenderInterestSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/interest/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderInterestSmsTemplateExampleApiArgSchema,
        responseSchema: renderSmsTemplateResponseBodySchema,
      },
    }),
    renderWorkshopInterestEmailTemplate: build.mutation<
      RenderWorkshopInterestEmailTemplateApiResponse,
      RenderWorkshopInterestEmailTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/workshop-interest/render-email`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderWorkshopInterestEmailTemplateApiArgSchema,
        responseSchema: renderEmailTemplateResponseBodySchema,
      },
    }),
    renderWorkshopInterestEmailTemplateExample: build.mutation<
      RenderWorkshopInterestEmailTemplateExampleApiResponse,
      RenderWorkshopInterestEmailTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/workshop-interest/render-email-example`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderWorkshopInterestEmailTemplateExampleApiArgSchema,
        responseSchema: renderEmailTemplateResponseBodySchema,
      },
    }),
    renderWorkshopInterestSmsTemplate: build.mutation<
      RenderWorkshopInterestSmsTemplateApiResponse,
      RenderWorkshopInterestSmsTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/workshop-interest/render-sms`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderWorkshopInterestSmsTemplateApiArgSchema,
        responseSchema: renderSmsTemplateResponseBodySchema,
      },
    }),
    renderWorkshopInterestSmsTemplateExample: build.mutation<
      RenderWorkshopInterestSmsTemplateExampleApiResponse,
      RenderWorkshopInterestSmsTemplateExampleApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/context/workshop-interest/render-sms-example`,
        method: 'POST',
        body: queryArg.body,
      }),
      extraOptions: {
        requestSchema: renderWorkshopInterestSmsTemplateExampleApiArgSchema,
        responseSchema: renderSmsTemplateResponseBodySchema,
      },
    }),
    getCustomerMessageDefinition: build.query<
      GetCustomerMessageDefinitionApiResponse,
      GetCustomerMessageDefinitionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/customer-message/${queryArg.id}/definition`,
      }),
    }),
    listLatestSchedulerRuns: build.query<
      ListLatestSchedulerRunsApiResponse,
      ListLatestSchedulerRunsApiArg
    >({
      query: () => ({
        url: `/dms/v1/messaging/scheduler/run/latest`,
      }),
      providesTags: (result) =>
        result?.runs
          ? [
              ...result.runs.map(({name}) => ({type: 'SchedulerRuns' as const, id: name})),
              {type: 'SchedulerRuns', id: 'LIST'},
            ]
          : [{type: 'SchedulerRuns', id: 'LIST'}],
    }),
    deleteLatestSchedulerRun: build.mutation<
      DeleteLatestSchedulerRunApiResponse,
      DeleteLatestSchedulerRunApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/scheduler/${queryArg.schedulerName}/run/latest`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'SchedulerRuns', id: queryArg.schedulerName},
        {type: 'SchedulerRuns', id: 'LIST'},
      ],
    }),
    runScheduler: build.mutation<RunSchedulerApiResponse, RunSchedulerApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/scheduler/${queryArg.schedulerName}/run`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'SchedulerRuns', id: queryArg.schedulerName},
        {type: 'SchedulerRuns', id: 'LIST'},
      ],
    }),
    renderCustomerMessageEmailTemplateV2: build.mutation<
      RenderCustomerMessageEmailTemplateV2ResponseBody,
      RenderCustomerMessageEmailTemplateV2ApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/messaging/customer-message/${queryArg.customerMessageId}/email/render`,
        method: 'POST',
        body: queryArg.renderCustomerMessageRequestBodyV2,
      }),
    }),
    getMessagingAllowlist: build.query<
      GetMessagingAllowlistApiResponse,
      GetMessagingAllowlistApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/allowlist/${queryArg.channel}`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'MessagingAllowlist', id: queryArg.channel},
      ],
    }),
    updateMessagingAllowlist: build.mutation<
      UpdateMessagingAllowlistApiResponse,
      UpdateMessagingAllowlistApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/allowlist/${queryArg.channel}`,
        method: 'PUT',
        body: queryArg.body,
      }),
      invalidatesTags: invalidateOnSuccess((_result, queryArg: UpdateMessagingAllowlistApiArg) => [
        {type: 'MessagingAllowlist', id: queryArg.channel},
      ]),
    }),
    listUserMailboxes: build.query<ListUserMailboxesApiResponse, ListUserMailboxesApiArg>({
      query: () => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox`,
      }),
      providesTags: ['UserMailbox'],
    }),
    listCustomerMessages: build.query<ListCustomerMessagesApiResponse, ListCustomerMessagesApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/customerV2/${queryArg.customerId}/customer-message`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          recordId: queryArg.recordId,
          resourceId: queryArg.resourceId,
        },
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'CustomerMessage', id: queryArg.customerId},
      ],
    }),
    createGoogleUserMailbox: build.mutation<
      CreateGoogleUserMailboxApiResponse,
      CreateGoogleUserMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox/google`,
        method: 'POST',
        body: queryArg.createUserGoogleMailboxRequestBody,
      }),
      invalidatesTags: ['UserMailbox'],
    }),
    createMicrosoftUserMailbox: build.mutation<
      CreateMicrosoftUserMailboxApiResponse,
      CreateMicrosoftUserMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox/microsoft`,
        method: 'POST',
        body: queryArg.createUserMicrosoftMailboxRequestBody,
      }),
      invalidatesTags: ['UserMailbox'],
    }),
    createImapUserMailbox: build.mutation<
      CreateImapUserMailboxApiResponse,
      CreateImapUserMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox/imap`,
        method: 'POST',
        body: queryArg.createUserImapMailboxRequestBody,
      }),
      invalidatesTags: ['UserMailbox'],
    }),
    updateImapUserMailbox: build.mutation<
      UpdateImapUserMailboxApiResponse,
      UpdateImapUserMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox/imap/${queryArg.mailboxId}`,
        method: 'PUT',
        body: queryArg.updateUserImapMailboxRequestBody,
      }),
      invalidatesTags: ['UserMailbox'],
    }),
    deleteUserMailbox: build.mutation<DeleteUserMailboxApiResponse, DeleteUserMailboxApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox/${queryArg.mailboxId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UserMailbox'],
    }),
    reauthenticateUserMailbox: build.mutation<
      ReauthenticateUserMailboxApiResponse,
      ReauthenticateUserMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/user-mailbox/${queryArg.mailboxId}/reauthenticate`,
        method: 'POST',
        body: queryArg.reauthenticateUserMailboxRequestBody,
      }),
      invalidatesTags: ['UserMailbox'],
    }),
    listTenantMailboxes: build.query<ListTenantMailboxesApiResponse, ListTenantMailboxesApiArg>({
      query: () => ({
        url: `/dms/v1/messaging/email/sync/tenant-mailbox`,
      }),
      providesTags: ['TenantMailbox'],
    }),
    createGoogleTenantMailbox: build.mutation<
      CreateGoogleTenantMailboxApiResponse,
      CreateGoogleTenantMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/tenant-mailbox/google`,
        method: 'POST',
        body: queryArg.createTenantGoogleMailboxRequestBody,
      }),
      invalidatesTags: ['TenantMailbox'],
    }),
    createMicrosoftTenantMailbox: build.mutation<
      CreateMicrosoftTenantMailboxApiResponse,
      CreateMicrosoftTenantMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/tenant-mailbox/microsoft`,
        method: 'POST',
        body: queryArg.createTenantMicrosoftMailboxRequestBody,
      }),
      invalidatesTags: ['TenantMailbox'],
    }),
    createImapTenantMailbox: build.mutation<
      CreateImapTenantMailboxApiResponse,
      CreateImapTenantMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/tenant-mailbox/imap`,
        method: 'POST',
        body: queryArg.createTenantImapMailboxRequestBody,
      }),
      invalidatesTags: ['TenantMailbox'],
    }),
    deleteTenantMailbox: build.mutation<DeleteTenantMailboxApiResponse, DeleteTenantMailboxApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/tenant-mailbox/${queryArg.mailboxId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TenantMailbox'],
    }),
    reauthenticateTenantMailbox: build.mutation<
      ReauthenticateTenantMailboxApiResponse,
      ReauthenticateTenantMailboxApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/messaging/email/sync/tenant-mailbox/${queryArg.mailboxId}/reauthenticate`,
        method: 'POST',
        body: queryArg.reauthenticateTenantMailboxRequestBody,
      }),
      invalidatesTags: ['TenantMailbox'],
    }),
  }),
});

export const {
  useRenderCustomerMessageEmailTemplateV2Mutation,
  usePatchOAuthEmailCredentialsMutation,
  useListLatestSchedulerRunsQuery,
  useDeleteLatestSchedulerRunMutation,
  useRunSchedulerMutation,
  useGetCustomerMessageDefinitionQuery,
  useRenderRentalOrderEmailTemplateMutation,
  useRenderRentalOrderEmailTemplateExampleMutation,
  useRenderRentalOrderSmsTemplateMutation,
  useRenderRentalOrderSmsTemplateExampleMutation,
  useRenderVehicleEmailTemplateMutation,
  useRenderVehicleEmailTemplateExampleMutation,
  useRenderVehicleSmsTemplateMutation,
  useRenderVehicleSmsTemplateExampleMutation,
  useRenderTireSetEmailTemplateExampleMutation,
  useRenderTireSetSmsTemplateExampleMutation,
  useRenderInterestEmailTemplateMutation,
  useRenderInterestEmailTemplateExampleMutation,
  useRenderInterestSmsTemplateMutation,
  useRenderInterestSmsTemplateExampleMutation,
  useRenderWorkshopInterestEmailTemplateMutation,
  useRenderWorkshopInterestEmailTemplateExampleMutation,
  useRenderWorkshopInterestSmsTemplateMutation,
  useRenderWorkshopInterestSmsTemplateExampleMutation,
  useRenderCustomerMessageEmailTemplateMutation,
  useRenderCustomerMessageSmsTemplateMutation,
  useSendCustomerSmsMutation,
  useSendWhatsAppContentMessageMutation,
  useGetLastKnownSmtpCredentialsQuery,
  useLazyGetLastKnownSmtpCredentialsQuery,
  useDiscoverEmailProviderMutation,
  useListEmailProviderQuery,
  useStartMicrosoftOAuth2Mutation,
  useCompleteMicrosoftOAuth2Mutation,
  useCreateMicrosoftOAuth2CredentialsMutation,
  useLazyListEmailCredentialsQuery,
  useCreateEmailSmtpCredentialsMutation,
  useTestEmailSmtpCredentialsMutation,
  useDeleteEmailCredentialsMutation,
  useListEmailCredentialsQuery,
  useSetDefaultEmailCredentialsMutation,
  useClearDefaultEmailCredentialsMutation,
  usePatchEmailSmtpCredentialsMutation,
  useCreateSignatureMutation,
  useSendCustomerEmailMutation,
  useSendCustomerEmailReplyMutation,
  useRenderCustomerEmailReplyMutation,
  useListSignaturesQuery,
  useRemoveSignatureMutation,
  useUpdateSignatureMutation,
  useLazyGetSignatureImagePermanentUriQuery,
  useGetNotificationDefinitionsQuery,
  useGetNotificationSettingsQuery,
  usePatchUserNotificationSettingsMutation,
  usePatchTenantNotificationSettingsMutation,
  usePreviewEmailNotificationQuery,
  useGetToastNotificationExampleQuery,
  useListNotificationDefinitionsQuery,
  useListSentToastNotificationsQuery,
  useGetSentToastNotificationQuery,
  useLazyGetSentBackgroundNotificationQuery,
  useLazyGetSentToastNotificationQuery,
  usePatchUnreadSentToastNotificationsMutation,
  usePatchSentToastNotificationMutation,
  useListContextParametersQuery,
  useCreateTemplateMutation,
  useGetTemplateQuery,
  usePatchTemplateMutation,
  useDeleteTemplateMutation,
  useRenderCustomerEmailTemplateExampleMutation,
  useRenderCustomerEmailTemplateMutation,
  useRenderCustomerSmsTemplateExampleMutation,
  useRenderCustomerSmsTemplateMutation,
  useRenderBusinessCaseEmailTemplateMutation,
  useRenderBusinessCaseSmsTemplateMutation,
  useRenderBusinessCaseEmailTemplateExampleMutation,
  useRenderBusinessCaseSmsTemplateExampleMutation,
  useRenderServiceOrderEmailTemplateExampleMutation,
  useRenderServiceOrderEmailTemplateMutation,
  useRenderServiceOrderSmsTemplateExampleMutation,
  useRenderServiceOrderSmsTemplateMutation,
  useGetContextTemplateListQuery,
  useGetMessagingAllowlistQuery,
  useUpdateMessagingAllowlistMutation,
  useListUserMailboxesQuery,
  useListCustomerMessagesQuery,
  useAssignSyncedMessageCustomerMutation,
  useUnassignSyncedMessageCustomerMutation,
  useAssignSyncedMessageRecordMutation,
  useUnassignSyncedMessageRecordMutation,
  useMarkSyncedMessagesAsReadMutation,
  useMarkCommunicationsAsOpenedMutation,
  useMarkCommunicationsAsReadMutation,
  useMarkCommunicationsAsUnreadMutation,
  useGetRecordUnreadCommunicationCountQuery,
  useGetUnreadCommunicationCountQuery,
  useCreateGoogleUserMailboxMutation,
  useCreateMicrosoftUserMailboxMutation,
  useCreateImapUserMailboxMutation,
  useUpdateImapUserMailboxMutation,
  useDeleteUserMailboxMutation,
  useReauthenticateUserMailboxMutation,
  useListTenantMailboxesQuery,
  useCreateGoogleTenantMailboxMutation,
  useCreateMicrosoftTenantMailboxMutation,
  useCreateImapTenantMailboxMutation,
  useDeleteTenantMailboxMutation,
  useReauthenticateTenantMailboxMutation,
} = messagingApi;
